
//系统目录 / 西药 接口相关的函数
import request from "../../untils/request.js"

/**
 * 
 *  post
 *  
 */

//新增科室档案
export const addDept = (data) => {
    return request.post("/outpatient/addDept", data )
}

//修改科室档案
export const updateDept = (data) => {
    return request.post("/outpatient/updateDept", data )
}

/**
 * 
 *  get
 *  
 */
// 诊所列表
export const docclinicList = (params) => {
    return request.get("/outpatient/docclinic/list", { params } )
}

// 列表
export const getDeptList = (params) => {
    return request.get("/outpatient/getDeptList", { params } )
}

// 科室专业列表
export const getDeptName = (params) => {
    return request.get("/outpatient/getDeptName", { params } )
}

// 
export const getDeptAttribute = (params) => {
    return request.get("/outpatient/getDeptAttribute", { params } )
}
/**
 * 
 * DELETE 
 *  
 */   


// 暴露
export default{
	getDeptList,getDeptName,addDept,updateDept,getDeptAttribute,docclinicList
}